export const ViewState = {
    NEW: 'new',
    EDIT: 'edit',
    READONLY: 'readonly',
};
export type ViewState = (typeof ViewState)[keyof typeof ViewState];
